module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('h2', [_vm._v("REMEMBER THE PAST, PAVE THE WAY FOR THE FUTURE")]), _vm._v(" "), _c('div', {
    staticClass: "font-lg"
  }, [_c('p', [_vm._v("\n                        Prosper ISD has seen its fair share of success over the decades in all of the extracurricular programs we offer culminating in the winning of the UIL 5A Lone Star Cup Award in the 2017-2018 school year. Now we have the opportunity to memorialize your contribution to our amazing school district in a beautiful display at the new Prosper ISD stadium set to open in the Fall of 2019.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        The Stadium Bricks are available in three styles. Each brick can be inscribed with your personal message and will be installed in the Summer/Fall of 2019. Brick packages include your brick installed at the stadium AND a complimentary replica brick created with the same material and message for display in your home or office. Display cases are also available to showcase this special keepsake!\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Become a special part of this celebration by purchasing a personalized engraved brick to commemorate your journey in Prosper ISD. Perfect for families, friends, teams, special events, and dedications, personalized Stadium Bricks make a lasting impression and a wonderful gift for the special influence in your life. This is a chance of a lifetime to forever etch your Prosper ISD loyalty in stone!\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "color-orange"
  }, [_c('router-link', {
    attrs: {
      "to": "/shop"
    }
  }, [_c('strong', [_vm._v("Click here to order your brick today!")])])], 1)]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/shop"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/aboutbricks.png",
      "alt": ""
    }
  })])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-801bfcd2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = q2Fu
// module chunks = 1